var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebpage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 7.83464C16.667 4.69194 16.667 3.12059 15.6907 2.14428C14.7144 1.16797 13.143 1.16797 10.0003 1.16797H8.33366C5.19096 1.16797 3.61961 1.16797 2.6433 2.14428C1.66699 3.12059 1.66699 4.69194 1.66699 7.83464V9.5013C1.66699 12.644 1.66699 14.2153 2.6433 15.1917C3.52921 16.0776 4.90507 16.1596 7.50032 16.1672H7.91699",
    stroke: "#337CC1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1071 17.0497C10.7343 17.1446 9.37416 10.7424 10.3081 9.80832C11.2421 8.87422 17.6447 10.2334 17.5498 11.6062C17.4845 12.5052 15.9628 12.8608 16.0072 13.6598C16.0202 13.8939 16.3158 14.1071 16.9071 14.5337C17.3179 14.8301 17.7368 15.118 18.1406 15.4239C18.3018 15.546 18.3654 15.7512 18.3181 15.9448C18.0908 16.8743 17.3784 17.5898 16.4451 17.8181C16.2515 17.8654 16.0463 17.8017 15.9242 17.6405C15.6184 17.2367 15.3305 16.8177 15.0342 16.4068C14.6077 15.8155 14.3944 15.5199 14.1604 15.5069C13.3615 15.4624 13.006 16.9843 12.1071 17.0497Z",
    stroke: "#337CC1",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 5.33594H16.667",
    stroke: "#337CC1",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebpage);
export default __webpack_public_path__ + "static/media/webpage.414042c5c1e94ccc15aaf39c666a92fb.svg";
export { ForwardRef as ReactComponent };